import { render, staticRenderFns } from "./SuggestedCourse.vue?vue&type=template&id=30f1250a&scoped=true"
import script from "./SuggestedCourse.vue?vue&type=script&lang=js"
export * from "./SuggestedCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f1250a",
  null
  
)

export default component.exports